
namespace Serenity {

    @Decorators.registerFormatter('Serenity.SingleLineFormatter')
    export class SingleLineFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            return SingleLineFormatter.formatValue(ctx.value);
        }

        public static formatValue(value: string) {
            return Q.htmlEncode(Q.toSingleLine(value));
        }
    }
}